import { Grid } from "@material-ui/core";
import React from "react";
import schoolIcon from "assets/icon/vuesax-outline-courthouse.svg";
import typeIcon from "assets/icon/Location.svg";
import eye from "assets/icon/vuesax-outline-eye.svg";
import charge from "assets/icon/vuesax-outline-lamp-charge.svg";
import message from "assets/icon/vuesax-outline-messages.svg";
import heart from "assets/icon/vuesax-bold-heart.svg";
import hintIcon from "assets/icon/Group 852.svg";
import Apis from "constants/Api";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
	activityCardContainer: {
		paddingBottom: 15,
		backgroundColor: "#fff",
		borderRadius: 25,
		userSelect: "none",
		transition: "all 0.2s linear",
		"&:hover": {
			boxShadow: "0 12px 20px 5px rgb(0 0 0 / 34%)",
		},
		[theme.breakpoints.down("sm")]: {
			maxWidth: 340,
		},
	},
	activityCardImageContainer: {
		padding: 10,
		userSelect: "none",
	},
}));

export default function ActivityCard({
	status,
	imgUrl,
	tag,
	tagColor,
	activityTitle,
	school,
	type,
	commentCount,
	driveCount,
	likeCount,
	viewCount,
	slug,
	section,
	index,
	border,
}) {
	const classes = useStyles();
	return (
		<Grid
			container
			direction="column"
			alignItems="center"
			id={`activity-card-${slug}`}
			className={classes.activityCardContainer}
			style={{ border: border && status === false ? "solid 2px #cf2647" : null }}
			component={Link}
			to={{ pathname: `/activity/detail/${slug}` }}
		>
			<Grid container className={classes.activityCardImageContainer}>
				{imgUrl ? (
					<img
						src={Apis.imageUrl + imgUrl}
						alt={activityTitle}
						style={{
							width: "100%",
							backgroundColor: "#eee",
							height: 190,
							borderRadius: 25,
						}}
					/>
				) : (
					<Grid
						item
						style={{
							width: "100%",
							backgroundColor: "#eee",
							height: 190,
							borderRadius: 25,
						}}
					/>
				)}
			</Grid>
			{border ? (
				<Grid
					item
					style={{
						backgroundColor: status === false ? "red" : status === true ? "green" : "#0c78a1",
						color: "#fff",
						marginTop: 13,
						marginBottom: 14,
						borderRadius: 13,
						height: "fit-content",
						padding: "3px 8px",
					}}
				>
					{status === false ? "رد شده" : status === true ? "تایید شده" : "درانتظار بررسی"}
				</Grid>
			) : null}

			<Grid
				container
				justify="center"
				wrap="nowrap"
				style={{
					fontWeight: "bold",
					marginBottom: 10,
				}}
			>
				<div
					className="activities_my_boom_activity_title"
					style={{
						textAlign: "center",
						fontSize: 17,
						whiteSpace: "nowrap",
						textOverflow: "ellipsis",
						width: 232,
						overflow: "hidden",
					}}
				>
					{activityTitle}
				</div>
			</Grid>
			<Grid
				container
				alignItems="center"
				style={{ marginBottom: 5, padding: "0px 10px" }}
				className="activities_my_boom_activity_school"
			>
				<img src={schoolIcon} alt="school" style={{ width: 13, marginLeft: 10 }} />
				<span>{school}</span>
			</Grid>
			<Grid
				container
				alignItems="center"
				style={{ marginBottom: 20, padding: "0px 10px" }}
				className="activities_my_boom_activity_location"
			>
				<img src={typeIcon} alt="type" style={{ width: 11, marginLeft: 10 }} />
				<span>{type}</span>
			</Grid>
			<Grid
				container
				justify="space-between"
				style={{
					padding: "3px 15px",
					marginTop: 20,
					display: status === false || status === null ? "none" : "flex",
				}}
			>
				<Grid
					item
					style={{ display: "flex", alignItems: "center" }}
					className="activities_my_boom_activity_view_count"
				>
					<img src={eye} alt="eye" style={{ marginLeft: 5, width: 15 }} />
					<span style={{ fontSize: 14 }}>{viewCount}</span>
				</Grid>
				<Grid
					item
					style={{ display: "flex", alignItems: "center" }}
					className="activities_my_boom_activity_comment_count"
				>
					<img src={message} alt="comment" style={{ marginLeft: 5, width: 15 }} />
					<span style={{ fontSize: 14 }}>{commentCount}</span>
				</Grid>

				<Grid
					item
					style={{ display: "flex", alignItems: "center" }}
					className="activities_my_boom_activity_get_guide_count"
				>
					<img src={charge} alt="hint" style={{ marginLeft: 5, width: 15 }} />
					<span style={{ fontSize: 14 }}>{driveCount}</span>
				</Grid>
				<Grid
					item
					style={{ display: "flex", alignItems: "center" }}
					className="activities_my_boom_activity_like_count"
				>
					<img src={heart} alt="heart" style={{ marginLeft: 5, width: 15 }} />
					<span style={{ fontSize: 14 }}>{likeCount}</span>
				</Grid>
			</Grid>
		</Grid>
	);
}
